export default __webpack_public_path__ + "static/media/status-ongoing.e99c4f1b.svg";